import xhr from 'live/services/xhr'

const BASE_LIVE_DASHBOARDS_URL = '/rest/dashboard'
const BASE_LIVE_REST_URL = '/rest'
const BASE_LIVERIG_SERVICES = '/services/plugin-liverig'

export function fetchDashboards(): Promise<any> {
    return xhr.get(BASE_LIVE_DASHBOARDS_URL)
}

export function getLookupAssetTypeIdName(): Promise<any> {
    return xhr.get(`${BASE_LIVE_REST_URL}/lookup/asset_type_id_name`).then(response => response.data)
}

export function getLookupAssetNameEventType(): Promise<any> {
    return xhr.get(`${BASE_LIVE_REST_URL}/lookup/asset_name_event_type`).then(response => response.data)
}

export function getAssets(): Promise<any> {
    return xhr.get('/services/plugin-liverig/assets/list').then(response => response.data.filter(d => !!d.name))
}

export function getRigById(id: string): Promise<any> {
    return xhr.get(`/services/plugin-liverig/assets/rig/${id}`).then(response => response)
}

export function getRigs(): Promise<any> {
    return xhr.get('/services/plugin-liverig/assets/rig').then(response => response.data.filter(d => !!d.name))
}

export function getWells(): Promise<any> {
    return xhr.get('/services/plugin-liverig/assets/well').then(response => response.data.filter(d => !!d.name))
}

export function getRigAttributes(id: string): Promise<any> {
    return xhr.get(`/services/plugin-liverig/assets/rig/view/attributes/${id}`).then(response => response.data)
}

export function getLookupAsset(): Promise<any> {
    return xhr.get(`/rest/lookup/asset_name_event_type`).then(response => response.data)
}

export function updateWidget(widget: Record<string, any> | { id: number }): Promise<any> {
    return widget.id && xhr.put(`/rest/dashboard-widget/${widget.id}`, widget)
}

export function getWellIntervention(id: string): Promise<any> {
    return xhr.get(`${BASE_LIVERIG_SERVICES}/assets/well/view/intervention/${id}`).then(response => response.data)
}

export function getWellInterventionStatus(): Promise<any> {
    return xhr.get(`${BASE_LIVERIG_SERVICES}/assets/intervention/`).then(response => response.data)
}

export function getWellInterventionDrillingSection(id: string): Promise<any> {
    return xhr
        .get(`${BASE_LIVERIG_SERVICES}/assets/intervention/${id}/part/drilling_sections`)
        .then(response => response.data)
}

export function fetchRigs() {
    return fetchAssets('rig')
}

export function fetchWells() {
    return fetchAssets('well')
}

export function fetchAssets(assetType: string) {
    return fetch(`/services/plugin-liverig/assets/${assetType}/search?`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' }
    })
        .then(r => r.json().then(data => ({ status: r.status, body: data })))
        .then(res => {
            return res.body
        })
}

const BASE_STATIC_DATA_MANAGER_URL = '/services/plugin-static-data-manager'

const URI = {
    intervention: '/intervention',
    rig: '/rig',
    well: '/well',
    section: '/section',
    run: '/run'
}

export interface StaticDataRig {
    id: number
    assetId: number
    interventions: { id: number }[]
}

export interface MD {
    id: number
    unitOfMeasure_id: number
    name: string
    value: number
}

export interface StaticDataIntervention {
    id: number
    rig_id: number
    well_id: number
    sections: { id: number }[]
    name: string
    tatic: string
    responsible: string
    start: number
    end: number
    isRealtime: boolean
}

export interface StaticDataWell {
    id: number
    assetId: string
    name: string
    fieldName: string
    waterDepth: {
        id: number
        unitOfMeasure_id: number
        name: string
        value: number
    }
    wellType: string
    wellCategory: string
    referenceSystem: string
    latitude: number
    longitude: number
}

export interface StaticDataSection {
    id: number
    intervention_id: number
    runs: { id: number; cementedPlugs: [] }[]
    name: number
    oD: {
        id: number
        unitOfMeasure_id: number
        name: number
        value: number
    }
    startMD: MD
    finalMD: MD
    start: number
    end: number
    riser: number
    type: number
}

export interface StaticDataTubulars {
    id: number
    run_id: number
    tubularType: string
    permanentTubularInstallation: number
    startMD: MD
    finalMD: MD
    connectionType: string
    materialType: string
    restrictedPipeMovements: []
    restrictedConnections: []
    restrictedRops: []
}

export interface StaticDataRun {
    id: number
    section_id: number
    tubulars: StaticDataTubulars[]
    number: number
    startMD: MD
    finalMD: MD
    start: number
    end: number
    type: string
    tubularsIntervalPerTime: boolean
    cementedPlugs: []
}

export function getIntervention(): Promise<StaticDataIntervention[]> {
    return xhr.get(BASE_STATIC_DATA_MANAGER_URL + URI.intervention + '/').then(response => response?.data)
}

export function getRig(): Promise<StaticDataRig[]> {
    return xhr.get(BASE_STATIC_DATA_MANAGER_URL + URI.rig + '/').then(response => response?.data)
}

export function getWell(): Promise<StaticDataWell[]> {
    return xhr.get(BASE_STATIC_DATA_MANAGER_URL + URI.well + '/').then(response => response?.data)
}

export function getSection(): Promise<StaticDataSection[]> {
    return xhr.get(BASE_STATIC_DATA_MANAGER_URL + URI.section + '/').then(response => response?.data)
}

export function getRun(): Promise<StaticDataRun[]> {
    return xhr.get(BASE_STATIC_DATA_MANAGER_URL + URI.run + '/').then(response => response?.data)
}

